




























import Vue from 'vue';
import ObjectAttributes from './ObjectAttributes.vue';
import MappedObjectAttributes from './MappedObjectAttributes.vue';

export default Vue.extend({
  name: 'DashboardBlockFilters',
  components: {
    ObjectAttributes,
    MappedObjectAttributes,
  },
  props: {
    selectedMetric: {
      type: Object,
      required: true,
    },
    selectedMetricChanged: {
      type: String,
      default: '',
    },
    currentMappedObjects: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      selectedObjectAttributes: [],
      selectedMappedObjectAttributes: [],
    };
  },
  computed: {
    emitValues() {
      return this.selectedObjectAttributes && this.selectedMappedObjectAttributes;
    },
    objectAttributes() {
      // TODO: Add also Custom Attributes
      return this.value.filter(
        item => item.name.type === 'ATTRIBUTE' || (item.name.type === 'CUSTOM_ATTRIBUTE' && !item.object)
      );
    },
    mappedObjectAttributes() {
      return this.value.filter(
        item => item.name.type === 'MAPPING_ATTR' || (item.name.type === 'CUSTOM_ATTRIBUTE' && item.object)
      );
    },
  },
  watch: {
    emitValues: {
      handler() {
        this.$emit('input', [...this.selectedObjectAttributes, ...this.selectedMappedObjectAttributes]);
      },
      deep: true,
    },
  },
  created() {},
});
